import { render, staticRenderFns } from "./StatisticIndex.vue?vue&type=template&id=2a74baf0"
import script from "./StatisticIndex.vue?vue&type=script&lang=js"
export * from "./StatisticIndex.vue?vue&type=script&lang=js"
import style0 from "./StatisticIndex.vue?vue&type=style&index=0&id=2a74baf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports